import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-6">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-4">
            Browse the <span className="text-primary-500">Vigorbuy Spreadsheet</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Navigate through 14 curated categories — every link updated and verified for the best shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer flex flex-col"
              data-product-shop
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-white/20 transition-colors mb-4">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-white transition-colors`}></i>
              </span>
              <h3 className="font-semibold text-foreground-950 group-hover:text-white text-sm md:text-base mb-1.5 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-foreground-500 group-hover:text-white/80 text-xs transition-colors line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-auto pt-4 flex items-center gap-1 text-primary-500 group-hover:text-white text-xs font-medium transition-colors whitespace-nowrap">
                Browse <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}